export function selectedShareLocation(currentHref: string, shareId: string): string {
  const next = new URL(currentHref);
  next.searchParams.set("share", shareId);
  return `${next.pathname}${next.search}${next.hash}`;
}
